import { __decorate, __metadata } from "tslib";
import { v4 as uuidv4 } from "uuid";
import { Type } from "class-transformer";
import { AssetPropertyModel } from "./assetProperty";
let AssetModel = /** @class */ (() => {
    class AssetModel {
        constructor() {
            this.id = uuidv4();
            this.assetTypeId = "";
            this.assetType = "";
            this.name = "";
            this.assetCode = "";
            this.price = null;
            this.statusId = "";
            this.vendorId = "";
            this.invoiceNumber = "";
            this.serialNumber = "";
            this.make = "";
            this.modelNumber = "";
            this.warrantyPeriod = 0;
            this.dateOfPurchaseAsString = "";
            this.warrantyStartDateAsString = "";
            this.warrantyEndDateAsString = "";
            this.assetLocationId = null;
        }
    }
    __decorate([
        Type(() => AssetPropertyModel),
        __metadata("design:type", Array)
    ], AssetModel.prototype, "assetProperties", void 0);
    return AssetModel;
})();
export { AssetModel };
export default class Asset extends AssetModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
